<template>
  <tuning-tool />
</template>

<script>

export default {
  name: 'Home',
  computed: {
    colorCode: {
      get() {
        return this.$store.state.colorCode
      }, 
      set(newval) {
        console.log("newval: " + newval)
        this.$store.dispatch('setColorCode', newval)
      }
    },
    makes: {
      get() {
        var a = this.$store.dispatch('apiRequest')
        return a
      }
    }
  },
  components: {
    'tuning-tool': require('@/components/TuningTool.vue').default,
    // 'counter': require('@/components/Counter.vue').default,
    // 'buttons': require('@/components/Buttons.vue').default
  }
}
</script>
